import { render } from "./checkin.view.vue?vue&type=template&id=99c400b2&ts=true"
import script from "./checkin.view.vue?vue&type=script&lang=ts"
export * from "./checkin.view.vue?vue&type=script&lang=ts"

import "./checkin.view.vue?vue&type=style&index=0&id=99c400b2&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__